import React from 'react'
import Table, { TableApiParamsType } from '../../components/Table'
import { axiosAPI } from '../../../engine/config/axios'

interface Params {
  userId: number
}

export default function UserRate({ userId } : Params) {
  const gridParams = {
    grids: [{ name: 'user_rates' }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
    filters: loadOptions?.filter,
    sort: loadOptions?.sort,
    userId,
    ...pageParams
  });

  return <Table
    apiParams={apiParams}
    gridParams={gridParams}
    api={axiosAPI.rates.table}
    gridName='user_rates'
    sortingMode='multiple'
  />
}
